export default __webpack_public_path__ + "static/media/constellations.ee76026c.png";